import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { AthleteAppointment, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

type NoShowAthleteAppointmentVars = {
  athleteAppointmentId: string;
  chargeNow: boolean;
  chargeDate: string | null;
  chargeFee: number;
  deductCredit: boolean;
  paymentMethod?: string | null;
  taxRate?: number | null;
  nonStripePaymentMethod?: string | null;
  autoPay?: boolean;
  addToNextInvoice?: boolean;
};

export default function useNoShowAthleteAppointment(): UseMutationResult<
  AxiosResponse<AthleteAppointment>,
  AxiosError<ErrorMessage>,
  NoShowAthleteAppointmentVars
> {
  const queryClient = useQueryClient();

  const noShowAthleteAppointment = ({
    athleteAppointmentId,
    ...payload
  }: NoShowAthleteAppointmentVars): Promise<AxiosResponse<AthleteAppointment>> => {
    return client.post(`athlete-appointments/${athleteAppointmentId}/no-show/`, payload);
  };

  return useMutation(noShowAthleteAppointment, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['athleteEvents'] });
      queryClient.invalidateQueries({ queryKey: ['athleteAppointments'] });
      queryClient.invalidateQueries({ queryKey: ['appointments'] });
      queryClient.invalidateQueries({ queryKey: 'events' });
      queryClient.invalidateQueries({ queryKey: ['totalAttended'] });
      queryClient.invalidateQueries({ queryKey: ['totalReserved'] });
    },
  });
}
